export interface SelectOptions {
  title: string;
  value: string;
}
